import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PanelMenuModule} from 'primeng/panelmenu';
import {ToastModule} from 'primeng/toast';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {DropdownModule} from 'primeng/dropdown';
import {TooltipModule} from 'primeng/tooltip';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {TreeModule} from 'primeng/tree';
import {PaginatorModule} from 'primeng/paginator';
import {SpinnerModule} from 'primeng/spinner';
import {ListboxModule} from 'primeng/listbox';
import {CheckboxModule} from 'primeng/checkbox';
import {DialogModule} from 'primeng/dialog';
import {FileUploadModule} from 'primeng/fileupload';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {InputMaskModule} from 'primeng/inputmask';
import {MultiSelectModule} from 'primeng/multiselect';
import {MenubarModule} from 'primeng/menubar';
import {TabViewModule} from 'primeng/tabview';
import {RadioButtonModule} from 'primeng/radiobutton';

@NgModule({
    imports: [
        CommonModule,
        PanelMenuModule,
        ToastModule,
        TableModule,
        ButtonModule,
        CalendarModule,
        DropdownModule,
        TooltipModule,
        InputTextModule,
        ConfirmDialogModule,
        TreeModule,
        InputTextareaModule,
        PaginatorModule,
        SpinnerModule,
        ListboxModule,
        CheckboxModule,
        DialogModule,
        FileUploadModule,
        AutoCompleteModule,
        InputMaskModule,
        MultiSelectModule,
        MenubarModule,
        TabViewModule,
        RadioButtonModule
    ],
    exports: [
        PanelMenuModule,
        ToastModule,
        TableModule,
        ButtonModule,
        CalendarModule,
        DropdownModule,
        TooltipModule,
        InputTextModule,
        ConfirmDialogModule,
        TreeModule,
        InputTextareaModule,
        PaginatorModule,
        SpinnerModule,
        ListboxModule,
        CheckboxModule,
        DialogModule,
        FileUploadModule,
        AutoCompleteModule,
        InputMaskModule,
        MultiSelectModule,
        MenubarModule,
        TabViewModule,
        RadioButtonModule
    ]
})

export class PrimeNgModule {

}

